import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LenguageService, LenguageName } from 'src/app/shared/services/lenguage.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-user-lenguage-config',
  templateUrl: './user-lenguage-config.component.html',
  styleUrls: ['./user-lenguage-config.component.scss', './../components-conf.scss']
})

export class UserLenguageConfigComponent implements OnInit {

  private subscriptions = new Subscription();
  
  public lenguagesOptions : any[]= [
    {name : "Peruano ps", value : "es"},
    {name : "Ingleishon", value : "en"},
  ]
  public lenguageSelected : LenguageName;




  constructor(
    private translate : TranslateService,
    private lenguageService : LenguageService
  ) {
    const enguageCollectionSub = this.lenguageService.lenguages$.subscribe((lenguages)=>{
      this.lenguagesOptions = lenguages
    })
    this.lenguageSelected = this.lenguageService.currentLenguageSubject.value;
  }

  ngOnInit(): void {
  }

  public selectLenguage(){
    this.lenguageService.selectLenguage(this.lenguageSelected)
  }

}
